import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['turboFrame']

  handleHistoryChange({ target: { value } }) {
    this.turboFrameTargets.forEach((turboFrameEl) => {
      turboFrameEl.hidden = turboFrameEl.getAttribute('data-day') !== value
    })
  }
}
